import React, { useState, useRef, useCallback, useEffect, useMemo } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useLoading } from "../../_shared/LoadingContext";
import { toast } from "react-toastify";
import ReCAPTCHA from "react-google-recaptcha";
import Select from "react-select";
import { useTranslation } from "react-i18next";
import cookies from "js-cookie";
import { useNavigate } from "react-router-dom";
import { getCustomProductById } from "../../_services/unlockPhone";
import "./samsungAccRemoval.css";
import httpRequest from '../../_services/httpServices'
import ServicePromotionVideos from "../../shared/videos/ServicePromotionVideos";
import Helper from "../../shared/NewHowitWork/Helper";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';


const SITE_KEY = process.env.REACT_APP_SITE_KEY;
const GoogleFRPSection = () => {
  const { t } = useTranslation();
  const [currentLanguageCode, setCurrentLanguageCode] = useState(cookies.get("i18next") || "en");
  return (
    <section className="py-md-5 py-4">
      <div className="container py-md-5">
        <div className="row row justify-content-center  align-items-center">
          <div className="col-md-4 col-12">
            <img className="img-fliud" src="/images/frplock.png" alt="frplock" width="100%" />
          </div>
          <div className="col-md-7 col-12 px-md-5 px-3">
            <h2 className="fw-semibold display-5 mt-md-5 mt-4">
              {t('frp1')}
            </h2>
            <p className=" imeiblacklist2 m-0 my-3">
              {t('frp2')}
            </p>
            <p className=" imeiblacklist2 m-0 my-3">
              {t('frp3')}
            </p>
          </div>
        </div>
      </div>
    </section>
  )
}
const WhyChooseUs = ({ title, whyChooseList = [], bgClass }) => {
  const { t } = useTranslation();
  return (
    <section className={`why-choose-us ${bgClass}`}>
      <div className="container p-3 py-md-5">
        <div className="row justify-content-center d-flex align-items-center">
          <div className="col-12 col-md-6 px-3 px-md-0">
            <h2 className="display-6 fw-bold">{title}</h2>
            <ul className="choose-us-list py-4 ps-3">
              {whyChooseList.length > 0 &&
                whyChooseList.map((item, index) => (
                  <li key={index} className="ps-2 list-title pb-4">
                    <span className="imeiblacklist fw-bold">{t(item.title)}</span>
                    <p className="pt-2">{t(item.text)}</p>
                  </li>
                ))}
            </ul>
          </div>

          <div className="col-10 col-md-5 text-center pb-4 py-md-0">
            <img
              className="img-fluid p-0 p-md-0"
              src="/images/Frame.png"
              alt="about-mission"
              width={"500"}
            />
          </div>
        </div>
      </div>
    </section>
  );
};


const SamsungServicePopup = ({ isOpen, onClose, handleServiceSelect }) => {

  const { t } = useTranslation();
  const [currentLanguageCode, setCurrentLanguageCode] = useState(cookies.get("i18next") || "en");
  return (
    <Dialog className="rounded-5"
      open={isOpen}
      onClose={onClose}
      aria-labelledby="samsung-frp-dialog-title"
      maxWidth="md"
      fullWidth
    >
      <DialogActions>
        <Button onClick={onClose} color="primary">
          <i class="fas fa-times text-dark fs-4"></i>
        </Button>
      </DialogActions>
      <h2 className="text-center fs-2 fw-bold">
      {t('frpM1a')}<br className="d-none d-md-block" /> {t('frpM1b')}
      </h2>

      <div className="row d-flex bg-samsung-modal my-2 rounded-5 p-2">
        {/* Standard */}
        <div className="col-12 col-md-6 py-4 pe-md-5 ">
          <h3 className="fs-3">{t('frpM3')}</h3>
          <p className="fs-6 standard-border pb-2">
          {t('frpM4')}
          </p>
          <h5 className="fs-3 fw-bold">$15</h5>
          <button
            onClick={() => handleServiceSelect({ value: "Samsung Standard", name: "Samsung Standard", price: 15.00, delivery_time: "48 business hours" })}
            className="text-decoration-none standard-btn-bg fs-6 py-3 w-100 rounded-2"
          >{t('frpMButton')}</button>
          <ul className="mt-4 text-sm space-y-1 text-gray-600">
            <li className="d-flex gap-2"><div><img className="img-fluid" src="/images/solar_check-read-bold-duotone.png" /></div> {t('frpM6')}</li>
            <li className="d-flex gap-2"><div><img className="img-fluid" src="/images/solar_check-read-bold-duotone.png" /></div> {t('frpM7')}</li>
            <li className="d-flex gap-2"><div><img className="img-fluid" src="/images/solar_check-read-bold-duotone.png" /></div> {t('frpM8')}</li>
            <li className="d-flex gap-2"><div><img className="img-fluid" src="/images/solar_check-read-bold-duotone.png" /></div> {t('frpM9')}</li>
            <li className="d-flex gap-2"><div><img className="img-fluid" src="/images/solar_check-read-bold-duotone.png" /></div> {t('frpM10')}</li>
          </ul>
        </div>

        {/* Premium */}
        <div className="col-12 col-md-6 p-4 rounded-5 bg-white order-first order-md-1">
          <h3 className="fs-3">{t('frpM11')}</h3>
          <p className="fs-6 standard-border pb-2">
          {t('frpM12')}
          </p>
          <h5 className="fs-3 fw-bold">$35</h5>
          <button
            onClick={() => handleServiceSelect({ value: "Samsung Premium", name: "Samsung Premium", price: 35.00, delivery_time: "48 business hours" })}
            className="text-decoration-none premium-btn-bg fs-6 py-3 w-100 rounded-2"
          >{t('frpMButton')}</button>
          <ul className="mt-4 text-sm space-y-1 text-gray-600">
            <li className="d-flex gap-2"><div><img className="img-fluid" src="/images/solar_check-read-bold-duotone.png" /></div> {t('frpM13')}</li>
            <li className="d-flex gap-2"><div><img className="img-fluid" src="/images/solar_check-read-bold-duotone.png" /></div> {t('frpM14')}</li>
            <li className="d-flex gap-2"><div><img className="img-fluid" src="/images/solar_check-read-bold-duotone.png" /></div> {t('frpM15')}</li>
            <li className="d-flex gap-2"><div><img className="img-fluid" src="/images/solar_check-read-bold-duotone.png" /></div> {t('frpM16')}</li>
            <li className="d-flex gap-2"><div><img className="img-fluid knox-guard" src="/images/solar_check-read-bold-duotone1.png" /></div> {t('frpM17')}</li>
          </ul>
        </div>
      </div>


    </Dialog>
  );
};

const SamsungAccRemoval = () => {
  const [showSamsungPopup, setShowSamsungPopup] = useState(false);
  const [selectedManufacturer, setSelectedManufacturer] = useState(null);

  const { t } = useTranslation();
  const [currentLanguageCode, setCurrentLanguageCode] = useState(cookies.get("i18next") || "en");
  const [youtubeUrls, setYoutubeUrls] = useState(null);
  // Define localized carrier data
  const localizedManufacturerData = useMemo(
    () => ({
      en: [
        { value: "Honor", name: "Honor", price: 49.99, delivery_time: "1-5 bussiness days" },
        // { value: "Huawei", name: "Huawei", price: 44.99, delivery_time: "1-3 bussiness days" },
        // { value: "Motorola", name: "Motorola", price: 59.99, delivery_time: "1-3 bussiness days" },
        { value: "Samsung", name: "Samsung", price: 30.00, delivery_time: "48 business hours" },
        // { value: "Samsung service 2", name: "Samsung service 2", price: 49.99, delivery_time: "1-3 bussiness days" },
        { value: "Xiaomi (Mi Account)", name: "Xiaomi (Mi Account)", price: 44.99, delivery_time: "1-5 bussiness days" },
      ],
      es: [
        { value: "Honor", name: "Honor", price: 49.99, delivery_time: "1-5 bussiness days" },
        // { value: "Huawei", name: "Huawei", price: 44.99, delivery_time: "1-3 bussiness days" },
        // { value: "Motorola", name: "Motorola", price: 59.99, delivery_time: "1-3 bussiness days" },
        { value: "Samsung", name: "Samsung", price: 30.00, delivery_time: "48 business hours" },
        // { value: "Samsung service 2", name: "Samsung service 2", price: 49.99, delivery_time: "1-3 bussiness days" },
        { value: "Xiaomi (Cuenta Mi)", name: "Xiaomi (Cuenta Mi)", price: 44.99, delivery_time: "1-5 bussiness days" },
      ],
    }),
    []
  );
  // Compute carrierData based on currentLanguageCode
  const manufacturerData = localizedManufacturerData[currentLanguageCode];
  const navigate = useNavigate();
  const [state, setState] = useState({
    productData: [],
    formValue: null,
    validToken: [],
  });
  const { startLoading, stopLoading } = useLoading();
  const captchaRef = useRef(null);
  // State to force re-rendering of the ReCAPTCHA component
  const [captchaKey, setCaptchaKey] = useState(Date.now()); // Use timestamp as a key for re-rendering
  // Reload captcha when language changes
  useEffect(() => {
    const handleLanguageChange = () => {
      const newLanguageCode = cookies.get("i18next") || "en";

      if (newLanguageCode === "en") { setYoutubeUrls('https://youtu.be/45b6BZyg23w') } else {
        setYoutubeUrls('https://youtu.be/QN-rOHt0b5M')

      }
      if (newLanguageCode !== currentLanguageCode) {
        setCurrentLanguageCode(newLanguageCode);
        // Change the key to remount ReCAPTCHA
        setCaptchaKey(Date.now());
      }
    };
    // Listen for cookie changes or language changes (you could also use another event)
    const intervalId = setInterval(handleLanguageChange, 1000); // Polling for language changes (or use other detection)
    return () => clearInterval(intervalId); // Cleanup the interval on component unmount
  }, [currentLanguageCode]);
  const whyChooseList = [
    { title: "whyush1", text: "whyusp1" },
    { title: "whyush2", text: "whyusp2" },
    { title: "whyush3", text: "whyusp3" },
    { title: "whyush4", text: "whyusp4" },
    { title: "whyush5", text: "whyusp5" },
    { title: "whyush6", text: "whyusp6" }
  ];
  useEffect(() => {
    setYoutubeUrls('https://youtu.be/45b6BZyg23w')
    const fetchProductData = async () => {
      try {
        const res = await getCustomProductById(4);
        setState((prevState) => ({ ...prevState, productData: res }));
      } catch (error) {
        toast.error("Error fetching product data.");
      } finally {
      }
    };
    fetchProductData();
  }, []);

  const validationSchema = Yup.object({
    imei: Yup.string()
      .required(t("ErrorField4"))
      .length(15, t("ErrorField41")),
    email: Yup.string().email(t("ErrorField51")).required(t("ErrorField5")),
    manufacturer: Yup.string().required(t("ErrorField2")),
  });

  // Verify reCAPTCHA token
  const verifyToken = useCallback(async (token) => {
    try {
      const response = await httpRequest.post(`${process.env.REACT_APP_API_URL}/verifyToken`, {
        reCAPTCHA_TOKEN: token,
      });
      toast.success(t("IEMIS1"));

      return [response];
    } catch (error) {
      console.error("Error verifying token:", error);
      return [];
    }
  }, [t]);

  const handleSubmit = useCallback(
    async (values, { resetForm }) => {
      try {
        const token = captchaRef.current.getValue();
        captchaRef.current.reset();

        if (!token) {
          return toast.error(t("Sorry!! Verify you're not a bot"));
        }

        startLoading();
        const validTokenResponse = await verifyToken(token);
        if (!validTokenResponse[0]?.success) {
          throw new Error("Verification failed");
        }

        const updatedValues = {
          ...values,
          carrier: "Global",
          model: "FRP/Google Account Removal",
          phone: "",
        };

        setState((prevState) => ({
          ...prevState,
          formValue: updatedValues,
          validToken: validTokenResponse,
        }));

        navigate("/review-order", { state: { formValue: updatedValues, productData: state.productData } });
        localStorage.setItem("state", JSON.stringify({ formValue: updatedValues, productData: state.productData }));
      } catch (error) {
        toast.error("Something went wrong.");
      } finally {
        stopLoading();
      }
    },
    [navigate, state.productData, t, startLoading, stopLoading]
  );

  const handleServiceSelect = (service, setFieldValue) => {
    setSelectedManufacturer(service);
    setFieldValue("manufacturer", service.name); // sync to Formik
  
    setState(prev => ({
      ...prev,
      productData: prev.productData.map((product) => ({
        ...product,
        price: service.price,
        delivery_time: service.delivery_time
      }))
    }));
  
    setShowSamsungPopup(false);
  };
  

  const handleManufacturerChange = async (selectedOption, handleChange) => {
    const { name } = selectedOption.value;
    if (name === "Samsung") {
      setShowSamsungPopup(true);
      handleChange("manufacturer")(""); // clear field
      setSelectedManufacturer(null);
      return;
    }
    handleChange("manufacturer")(name);
    setState(prev => ({
      ...prev,
      productData: [{ price: selectedOption.value.price, delivery_time: selectedOption.value.delivery_time }]
    }));
  };




  return (
    <div>
      <section className="banner-ImeiBlacklist py-md-2 pt-md-5 pt-0 pb-0 position-relative">
        <div className="container py-2 pt-md-4 pb-md-5">
          <div className="row justify-content-center p-3 p-md-0">
            <div className="col-md-6 col-12 px-md-5 p-0">
              <h1 className="fw-semibold display-5 mt-md-5">
                {t('SAR1')}
              </h1>
              <p className=" imeiblacklist2 m-0 my-3">
                {t('SAR2')}
              </p>
              <p className=" imeiblacklist2 m-0">
                {t('SAR3')}
              </p>
            </div>
            <div className="col-12 col-md-6 mt-md-0 mt-3 p-0">
              <div className="px-md-4">
                <>
                  <Formik
                    initialValues={{ imei: "", email: "", manufacturer: "" }}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                  >
                    {({ handleChange, values, handleBlur, setFieldValue }) => (
                      <Form className="bg-white rounded p-4 form-border">
                        <div className="card unlock-card bg-transparent border-0 my-md-0 my-1">
                          <div className="card-body">
                            <h5 className="fw-semibold mb-4">{t("SARh111")}</h5>
                            <div>
                              <p className="mb-0 fw-semibold mb-2">{t("SARh2")}</p>
                              <div className="input-group border d-flex align-items-center p-2 rounded mb-3 bg-white w-100">
                                <label className="input-group-text bg-transparent border-0" htmlFor="imei">
                                  <img loading="lazy" src="/images/ph_phone-call (1).svg" alt="" />
                                  <span className="mx-2mx-0 text-secondary"> | </span>
                                </label>
                                <Field
                                  type="text"
                                  className="form-control border-0 py-1"
                                  placeholder={t("FormField4")}
                                  aria-label={t("FormField4")}
                                  id="imei"
                                  name="imei"
                                  onChange={handleChange}
                                />
                              </div>
                            </div>
                            <ErrorMessage name="imei" component="div" className="error-message ps-5 ms-4" />
                            <div>
                              <p className="mb-0 fw-semibold">Email</p>
                              <div className="input-group border d-flex align-items-center p-2 rounded mb-3 bg-white w-100">
                                <label className="input-group-text bg-transparent border-0" htmlFor="email">
                                  <img loading="lazy" src="/images/at-sign2.svg" alt="" />
                                  <span className="mx-2mx-0 text-secondary"> | </span>
                                </label>
                                <Field
                                  type="email"
                                  className="form-control border-0 py-1"
                                  placeholder={t("FormField5")}
                                  aria-label={t("FormField5")}
                                  id="email"
                                  name="email"
                                  onChange={handleChange}
                                />
                              </div>
                            </div>
                            <ErrorMessage name="email" component="div" className="error-message ps-5 ms-4" />
                            <div>
                              <h6 className="fw-semibold small-font">{t("Formlabel2")}</h6>
                              <div className="input-group mb-3 border rounded-input d-flex justify-content-between">
                                <label
                                  className="input-group-text border-0 bg-transparent"
                                  htmlFor="carrier"
                                >
                                  <img
                                    loading="lazy"
                                    src="/images/manufacturer.svg"
                                    alt=""
                                    width={'20'}
                                  />
                                  <span class="mx-2mx-0 text-secondary"> | </span>
                                </label>
                                <Select
                                  className="form-select-carrier border-0"
                                  id="manufacturer"
                                  name="manufacturer"
                                  options={manufacturerData?.map((manufacturer) => ({
                                    value: manufacturer,
                                    label: manufacturer.name,
                                  }))}
                                  value={
                                    selectedManufacturer
                                      ? { value: selectedManufacturer, label: selectedManufacturer.name }
                                      : manufacturerData.find((option) => option.value.name === values.manufacturer)
                                  }
                                  onChange={(selectedOption) => {
                                    const { value } = selectedOption;
                                    if (value.name === "Samsung") {
                                      setShowSamsungPopup(true);
                                      setFieldValue("manufacturer", "");
                                      setSelectedManufacturer(null);
                                    } else {
                                      setFieldValue("manufacturer", value.name);
                                      setSelectedManufacturer(value);
                                      setState(prev => ({
                                        ...prev,
                                        productData: prev.productData.map((product) => ({
                                          ...product,
                                          price: value.price,
                                          delivery_time: value.delivery_time
                                        }))
                                      }));
                                      
                                    }
                                  }}
                                  isSearchable={true}
                                  filterOption={(option, inputValue) =>
                                    option.label.toLowerCase().includes(inputValue.toLowerCase())
                                  }
                                  placeholder={t("FormField2")}
                                />

                              </div>
                            </div>
                            <ErrorMessage name="manufacturer" component="div" className="error-message ps-5 ms-4" />

                            <button type="submit" className="btn btn-lg mt-md-0 mt-2 w-100 unlock-btn">
                              {t("Button3")}
                            </button>
                          </div>
                        </div>
                        <SamsungServicePopup
                          isOpen={showSamsungPopup}
                          onClose={() => setShowSamsungPopup(false)}
                          handleServiceSelect={(service) => handleServiceSelect(service, setFieldValue)}
                        />

                      </Form>

                    )}
                  </Formik>
                  <div>
                    <ReCAPTCHA
                      key={captchaKey}
                      className="recaptcha"
                      sitekey={"6LeLE9YqAAAAADOc0-cFTfmPBQRxgXbIGjXi-FQH"}
                      ref={captchaRef}
                      hl={currentLanguageCode}
                    />
                  </div>
                </>
              </div>
              <div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <GoogleFRPSection />
      <WhyChooseUs
        title={t("whyush")}
        bgClass="bg-class"
        whyChooseList={[
          { title: "whyush1", text: "whyusp1" },
          { title: "whyush2", text: "whyusp2" },
          // { title: "whyush3", text: "whyusp3" },
          { title: "whyush4", text: "whyusp4" },
          { title: "whyush5", text: "whyusp5" },
          { title: "whyush6", text: "whyusp6" }
        ]}
      />
      {/* {youtubeUrls && <ServicePromotionVideos youtubeUrls={[youtubeUrls]} title={t('SAR1')} />} */}

    </div>
  );
};

export default SamsungAccRemoval;
